import React from 'react';
import { Building2, Film, Award, Radio, Briefcase } from 'lucide-react';

const WhoIWorkWith = () => {
  const clientTypes = [
    { icon: Building2, label: "Production Companies", color: "text-[#818BB1]" },
    { icon: Award, label: "Cultural Institutions", color: "text-[#818BB1]" },
    { icon: Film, label: "Film Festivals & Markets", color: "text-[#818BB1]" },
    { icon: Radio, label: "Media & Entertainment Platforms", color: "text-[#818BB1]" },
    { icon: Briefcase, label: "Brands & Agencies", color: "text-[#818BB1]" },
    { icon: Film, label: "Talents & Crew", color: "text-[#818BB1]" }
  ];

  return (
    <section id="who-i-work-with" className="py-20 bg-midnight-blue relative overflow-hidden">
      <div className="container mx-auto px-8 md:px-16 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-16">
            <h2 className="text-[20px] tracking-[0.2em] uppercase text-white font-montserrat font-bold mb-6">
              Who I Work With
            </h2>
            <h2 className="font-playfair font-bold text-3xl md:text-4xl text-terracotta mb-4">
              Trusted by Leading Organizations
            </h2>
          </div>

          {/* Client types grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {clientTypes.map((client, index) => {
              const Icon = client.icon;
              return (
                <div
                  key={index}
                  className="group bg-white/5 hover:bg-white/10 p-8 rounded-sm border border-white/10 hover:border-[#818BB1]/30 transition-all duration-300 text-center"
                >
                  <Icon className={`w-12 h-12 mx-auto mb-4 ${client.color} group-hover:text-cream transition-colors`} strokeWidth={1.5} />
                  <p className="text-white/90 font-montserrat font-medium text-sm leading-tight">
                    {client.label}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIWorkWith;
